import { render, staticRenderFns } from "./limiti.vue?vue&type=template&id=3f3a4f81&scoped=true"
import script from "./limiti.vue?vue&type=script&lang=js"
export * from "./limiti.vue?vue&type=script&lang=js"
import style0 from "./limiti.vue?vue&type=style&index=0&id=3f3a4f81&prod&lang=scss&scoped=true"
import style1 from "./limiti.vue?vue&type=style&index=1&id=3f3a4f81&prod&lang=scss"
import style2 from "./limiti.vue?vue&type=style&index=2&id=3f3a4f81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a4f81",
  null
  
)

export default component.exports